export default __webpack_public_path__ + "static/media/documenticon.9c41030a.svg";